import * as React from 'react';
import PageTitle from 'components/PageTitle';
import Button from 'sharedComponents/core/Input/Button';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from 'helpers/theme';
import { useDelegateDetailsDispatch } from 'views/DelegateDetailsProvider';
import { useBookingModalDispatch } from 'views/BookingModalProvider';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex'
  },
  infoHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2)
  },
  mainButtons: {
    display: 'inline-grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(2)
  }
}));

type Props = {
  title: string;
  subTitle: string;
  sideText?: string;
  sideComponent?: React.ReactNode;
  backProps?: {
    text: string;
    onClick: Function;
  };
};
const PageHeader = ({
  title,
  subTitle,
  sideText,
  sideComponent,
  backProps
}: Props) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.infoHeader}>
      <PageTitle
        title={title}
        subTitle={subTitle}
        sideText={sideText}
        sideComponent={sideComponent}
        backProps={backProps}
      />
    </div>
  );
};

export default PageHeader;
